export const SO_CONTENT = {
  hero: {
    kicker: 'Para quem abre e cobra por ordem de serviço',
    title: 'Ordem de serviço no papel ou na planilha é dinheiro que você esquece de cobrar.',
    subtitle:
      'Abra, acompanhe e finalize cada ordem de serviço vinculada ao cliente, com faturamento e NFS-e gerados automaticamente no fechamento. Sem perder o fio da meada.',
    cta: 'Quero organizar minhas OS',
    ctaMessage: 'Quero conhecer o sistema de ordem de serviço do 77Gestão',
    urgency: 'Cada OS perdida no papel é um serviço que você já fez e ainda não cobrou.',
  },

  statsStrip: [
    { number: '1 clique', label: 'para gerar a NFS-e da OS concluída', icon: 'fa-solid fa-file-invoice' },
    { number: 'Zero', label: 'serviços esquecidos sem cobrar', icon: 'fa-solid fa-triangle-exclamation' },
    { number: 'Tempo real', label: 'status visível para o cliente', icon: 'fa-solid fa-eye' },
  ],

  pain: {
    title: 'Se sua OS ainda vive no papel ou na planilha, você reconhece isso',
    intro:
      'Empresas que prestam serviço perdem faturamento e credibilidade todos os dias por falta de controle sobre as ordens de serviço abertas.',
    items: [
      { icon: 'fa-solid fa-file-lines', text: 'OS anotada em papel, caderno ou planilha solta — fácil de perder ou esquecer.' },
      { icon: 'fa-solid fa-clock-rotate-left', text: 'Cliente liga perguntando "e o meu serviço, como está?" e você não tem resposta na hora.' },
      { icon: 'fa-solid fa-money-bill-transfer', text: 'Serviço concluído e esquecido de faturar — o trabalho foi feito, mas nunca cobrado.' },
      { icon: 'fa-solid fa-clipboard-question', text: 'Sem histórico do que já foi feito antes para aquele cliente ou equipamento.' },
      { icon: 'fa-solid fa-people-arrows', text: 'Cada atendente organiza a OS do seu jeito — ninguém enxerga o mesmo painel.' },
      { icon: 'fa-solid fa-file-invoice', text: 'Depois de concluir o serviço, ainda falta emitir a nota manualmente em outro sistema.' },
    ],
  },

  midCta: {
    text: 'E se toda OS aberta já mostrasse o status, o histórico do cliente e gerasse a nota fiscal sozinha no fechamento?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de ordem de serviço do 77Gestão',
  },

  solution: {
    title: 'Da abertura ao faturamento, tudo em um só lugar',
    intro:
      'O módulo de ordens de serviço do 77Gestão organiza cada etapa do atendimento, vinculada ao cliente certo, sem depender de papel ou planilha.',
    cards: [
      {
        icon: 'fa-solid fa-clipboard-list',
        title: 'OS vinculada ao cliente',
        text: 'Toda ordem de serviço nasce ligada ao cadastro do cliente, com acesso ao histórico de tudo que já foi feito para ele antes.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Tipos de OS customizáveis',
        text: 'Configure os tipos de serviço que sua empresa presta — cada tipo com o fluxo que fizer sentido para o seu negócio.',
      },
      {
        icon: 'fa-solid fa-route',
        title: 'Status até a conclusão',
        text: 'Acompanhe cada ordem de serviço da abertura até a entrega, com o status atual sempre visível.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Faturamento com NFS-e automática',
        text: 'Ao concluir a OS, gere a nota fiscal de serviço automaticamente — sem digitar tudo de novo em outro sistema.',
      },
      {
        icon: 'fa-solid fa-user-tag',
        title: 'Portal do cliente',
        text: 'O cliente acompanha o status da própria OS e as parcelas por um link de acesso, sem precisar te ligar para perguntar.',
      },
      {
        icon: 'fa-solid fa-folder-open',
        title: 'Histórico completo por cliente',
        text: 'Veja tudo o que já foi feito para cada cliente — útil para orçar de novo, avaliar garantia ou entender recorrência.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a OS sai do papel',
    intro:
      'Uma prestadora de serviços organizava as ordens de serviço em blocos de papel e planilhas divididas entre vários atendentes — sem padrão e sem controle do que já tinha sido cobrado.',
    stats: [
      { number: '0', label: 'serviços concluídos sem faturar' },
      { number: '100%', label: 'das OS com status visível' },
      { number: '1 sistema', label: 'do orçamento à nota fiscal' },
    ],
    paragraphs: [
      'Depois da implantação acompanhada, cada ordem de serviço passou a nascer no sistema, vinculada ao cliente, com um tipo de serviço padronizado e status visível para toda a equipe.',
      'No fechamento, a nota fiscal de serviço passou a ser emitida direto da OS concluída — sem redigitar dados em outro sistema e sem esquecer de faturar.',
    ],
    highlight: 'Resultado: nenhuma ordem de serviço esquecida sem cobrança e faturamento no mesmo dia da conclusão.',
    cta: 'Quero esse mesmo controle',
    ctaMessage: 'Vi o resultado e quero entender como organizar as ordens de serviço da minha empresa no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão de ordens de serviço',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Você e o cliente sabem em que fase está cada serviço, sem precisar telefonar para perguntar.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Cada OS documentada, com tipo, status e histórico — nada se perde entre atendentes.',
      },
      {
        icon: 'fa-solid fa-bolt',
        title: 'Agilidade no faturamento',
        text: 'A nota fiscal de serviço sai direto da OS concluída, sem trabalho duplicado em outro sistema.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para controlar as ordens de serviço',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Tipos de OS configuráveis para o seu tipo de serviço, não um modelo engessado.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe começa a usar com segurança.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado.' },
      { icon: 'fa-solid fa-link', text: 'OS integrada com financeiro e fiscal — a nota sai sozinha, sem retrabalho.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Consigo criar tipos diferentes de ordem de serviço para cada tipo de atendimento que presto?',
        answer:
          'Sim. Você configura os tipos de OS de acordo com os serviços que sua empresa realiza, cada um com o fluxo que fizer sentido.',
      },
      {
        question: 'A nota fiscal sai automaticamente ou preciso emitir em outro lugar?',
        answer:
          'A NFS-e é gerada automaticamente a partir da ordem de serviço concluída, sem precisar lançar os dados de novo em outro sistema.',
      },
      {
        question: 'O cliente consegue acompanhar o andamento do serviço?',
        answer:
          'Sim. Pelo portal do cliente, com acesso por link, ele vê o status da OS e as parcelas relacionadas, sem precisar ligar para perguntar.',
      },
      {
        question: 'Funciona para equipe com mais de um atendente ou técnico?',
        answer:
          'Sim. Todo mundo trabalha no mesmo painel, com o mesmo padrão de abertura e acompanhamento — sem depender do caderno pessoal de cada um.',
      },
      {
        question: 'Preciso mudar todo meu processo de atendimento para usar o sistema?',
        answer:
          'Não. A implantação é acompanhada e adapta os tipos de OS ao processo que sua empresa já usa, só organizando tudo em um único sistema.',
      },
    ],
  },

  ctaFinal: {
    title: 'Cada OS perdida no papel é faturamento que você deixou de cobrar.',
    subtitle:
      'Agende uma demonstração e veja como abrir, acompanhar e faturar suas ordens de serviço em um único sistema, do início ao fim.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de ordem de serviço do 77Gestão',
  },

  seo: {
    title: 'Sistema de Ordem de Serviço Online | 77Gestão',
    description:
      'Sistema de ordem de serviço online: abra a OS vinculada ao cliente, acompanhe o status até a conclusão e gere a NFS-e automática. Agende uma demonstração.',
  },
};
